import Marquee from "react-fast-marquee";

/**
 * Premium text-based wordmark strip.
 * Each logo is a styled text-mark to keep rendering fast, reliable across all
 * networks, and consistent with the corporate-futuristic aesthetic.
 * Grouped by industry vertical served.
 */
const LOGOS = [
  // Banking & Finance
  { name: "JPMorgan", font: "font-display font-semibold tracking-tight", size: "text-2xl" },
  { name: "HSBC", font: "font-display font-bold tracking-wide", size: "text-2xl" },
  { name: "Goldman Sachs", font: "font-display font-light tracking-tight italic", size: "text-2xl" },
  { name: "Barclays", font: "font-display font-medium tracking-tight", size: "text-2xl" },
  // Aerospace & Defense
  { name: "BOEING", font: "font-display font-semibold tracking-[0.2em]", size: "text-xl" },
  { name: "AIRBUS", font: "font-sans font-bold tracking-[0.15em]", size: "text-xl" },
  { name: "Lockheed Martin", font: "font-display font-normal tracking-tight", size: "text-2xl" },
  { name: "Rolls-Royce", font: "font-display font-light tracking-tight italic", size: "text-2xl" },
  // Solar & Renewable Energy
  { name: "First Solar", font: "font-display font-medium tracking-tight", size: "text-2xl" },
  { name: "SunPower", font: "font-sans font-semibold tracking-tight", size: "text-2xl" },
  { name: "Enphase", font: "font-display font-light tracking-tight", size: "text-2xl" },
  { name: "TESLA", font: "font-display font-normal tracking-[0.4em]", size: "text-xl" },
  // Information Technology
  { name: "Microsoft", font: "font-sans font-normal tracking-tight", size: "text-2xl" },
  { name: "IBM", font: "font-display font-bold tracking-[0.05em]", size: "text-2xl" },
  { name: "ORACLE", font: "font-display font-medium tracking-[0.15em]", size: "text-xl" },
  { name: "accenture", font: "font-display font-light tracking-tight lowercase", size: "text-2xl" },
];

export default function TrustStrip() {
  return (
    <section
      data-testid="trust-strip"
      className="relative py-14 md:py-16 border-y border-white/10 bg-white/[0.02]"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 mb-8 flex items-center justify-between gap-6">
        <p className="text-xs md:text-sm uppercase tracking-[0.25em] text-slate-400">
          Serving leaders across regulated &amp; technical industries
        </p>
        <div className="hidden md:block h-px flex-1 bg-gradient-to-r from-white/10 to-transparent" />
      </div>

      <Marquee
        data-testid="trust-marquee"
        gradient
        gradientColor="#0B1120"
        gradientWidth={140}
        speed={38}
        pauseOnHover
      >
        {LOGOS.concat(LOGOS).map((l, i) => (
          <div
            key={`${l.name}-${i}`}
            className="mx-10 md:mx-14 flex items-center h-10 md:h-12"
          >
            <span
              className={`${l.font} ${l.size} text-slate-300/70 hover:text-white transition-colors duration-300 whitespace-nowrap`}
            >
              {l.name}
            </span>
          </div>
        ))}
      </Marquee>

      <p className="text-center text-[11px] uppercase tracking-[0.25em] text-slate-500 mt-8 px-6">
        Wordmarks represent industry verticals we specialise in · Not an endorsement
      </p>
    </section>
  );
}
